import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

@Component({
  selector: 'app-nudges-modal',
  templateUrl: './nudges-modal.component.html',
  styleUrls: ['./nudges-modal.component.css']
})
export class NudgesModalComponent implements OnInit {


  @Input() isNudgeModal = false;
  @Input() headingText = '';
  @Input() paragraphText = '';
  @Input() nudgeIcon: string;
  @Input() submitButtonText = '';

  @Input() storyNudgeType;
  @Output() emitOnHidden: EventEmitter<string> = new EventEmitter();
  @Output() emitOnSubmit: EventEmitter<string> = new EventEmitter();
  
  
  constructor( public mls : NewLanguageService) {
   }

  ngOnInit(): void {
    // 
  }

  onHidden(): void {
    this.isNudgeModal = false;
    this.emitOnHidden.emit(this.storyNudgeType);
  }

  onSubmit(): void {
    this.emitOnSubmit.emit(this.storyNudgeType);
  }
}
